import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Lightweight client for mobile/kiosk anonymous access.
// Auth features are disabled so that API calls are not blocked by
// the main client's auth initialization (getSession hangs when
// Supabase auth service is slow, which blocks ALL PostgREST calls
// on the shared client because they wait for the auth token).
export const supabaseAnon = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
    storageKey: 'sb-anon-auth-token',
  },
});

// E2E test hook (DEV only). Playwright runs against the Vite dev server, so
// `import.meta.env.DEV` is true there but false in any production build. This
// exposes the real auth client to tests so they can trigger the genuine
// sign-out path (`auth.signOut()` → the app's `SIGNED_OUT` listener →
// `clearLocalAuthState`) deterministically, without depending on which
// role-specific layout rendered the icon-only sign-out button. Never present
// in production bundles.
if (import.meta.env.DEV && typeof window !== 'undefined') {
  (window as unknown as { __supabase?: typeof supabase }).__supabase = supabase;
}

export type { User, Session } from '@supabase/supabase-js';
